import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarStroke = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 382C1 356 16 346 44 346L362 332L462 36C471 11 485 0 500 0C515 0 529 11 538 36L638 332L956 346C984 346 999 356 1000 382C1001 404 994 414 980 424L714 590L831 953C840 981 821 1000 794 1000C775 1000 767 997 750 981L500 752L252 979C234 996 227 1000 208 1000C176 1000 161 978 169 953L286 590L20 424C6 414 -1 404 0 382ZM59 369L373 562L243 935L220 919L500 658L780 919L757 935L627 562L941 369L948 404L582 398L483 69H516L418 398L52 404Z" })
});
export default SvgStarStroke;
